interface Props {
  className?: string;
  label: string;
}
const Label = ({ label, className }: Props) => {
  return <div className={className}>{label}</div>;
};

export default Label;
